import { useLocalStore } from 'mobx-react-lite';

import { IShareSelection } from 'APP/types/share';

export interface IButtonsShareCardPopupPresenterProps {
  onSubmit(selection: IShareSelection[]): Promise<void>;
}

export interface IButtonsShareCardPopupPresenter {
  selection: IShareSelection[];
  isSubmitting: boolean;
  hasSelected: boolean;
  onSelect(selection: IShareSelection[]): void;
  submit(): void;
}

export const useButtonsShareCardPresenter = ({
  onSubmit,
}: IButtonsShareCardPopupPresenterProps): IButtonsShareCardPopupPresenter => {
  const presenter = useLocalStore<IButtonsShareCardPopupPresenter>(() => ({
    isSubmitting: false,
    selection: [],

    get hasSelected(): boolean {
      return presenter.selection.length > 0;
    },

    async onSelect(data): Promise<void> {
      presenter.selection = data;
    },

    async submit(): Promise<void> {
      presenter.isSubmitting = true;
      await onSubmit(presenter.selection);
      presenter.isSubmitting = false;
    },
  }));

  return presenter;
};
